import { render, staticRenderFns } from "./VmLink.vue?vue&type=template&id=021735ca&scoped=true&"
import script from "./VmLink.vue?vue&type=script&lang=js&"
export * from "./VmLink.vue?vue&type=script&lang=js&"
import style0 from "./VmLink.vue?vue&type=style&index=0&id=021735ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021735ca",
  null
  
)

export default component.exports